import { Sample } from 'types';
import { BaseMeta } from 'types';

export const getMetas = (
    sample: Sample,
    showTags = true,
): BaseMeta<string>[] => {
    const instrumentFamily = sample?.instrumentFamily;
    const instruments = sample?.instruments ?? [];
    const sfxs = sample?.sfxs ?? [];
    const tags = sample?.tags ?? [];

    const unfilteredMetas: BaseMeta<string>[] = [
        ...(instrumentFamily ? [instrumentFamily] : []),
        ...(instruments ? instruments : []),
        ...(sfxs ? sfxs : []),
        ...(showTags && tags ? tags : []),
    ];

    const metas = [
        ...new Set(
            unfilteredMetas
                .filter((meta) => meta && !!meta?.code)
                .map((meta) => meta),
        ),
    ];

    return metas;
};
